import React from 'react';
import { Phone, FileText } from 'lucide-react';
export function StickyMobileCta() {
  return <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 shadow-[0_-4px_12px_-2px_rgba(0,0,0,0.08)] z-50 p-3" data-id="element-288">
      <div className="flex gap-2.5" data-id="element-289">
        <a href="tel:517-545-7772" className="flex-1 flex items-center justify-center gap-2 bg-brand-red hover:bg-brand-redHover text-white py-3.5 px-2 rounded-lg font-bold text-sm min-h-[44px]" aria-label="Call Kosin's Glass at 517-545-7772" data-id="element-290">
          <Phone className="w-4 h-4" data-id="element-291" />
          Call 517-545-7772
        </a>
        <a href="#quote-form" className="flex-1 flex items-center justify-center gap-2 bg-white text-slate-900 border border-slate-300 py-3.5 px-2 rounded-lg font-bold text-sm min-h-[44px]" aria-label="Request urgent auto glass quote" data-id="element-292">
          <FileText className="w-4 h-4 text-brand-red" data-id="element-293" />
          Request Quote
        </a>
      </div>
    </div>;
}